import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for geo targetables (single geo filter)
 */
export interface IGeoTargetable extends ITargetableBase {
  _cls: TargetableClass.geo;
  geo_filter: string;
}

/**
 * GeoTargetable class for single geo filter targetables
 */
export class GeoTargetable extends TargetableBase<IGeoTargetable> {
  public override className = TargetableClass.geo;

  public override getDefaults(): Partial<IGeoTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.geo,
    };
  }

  public override get constraints(): TConstraints<IGeoTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.geo],
      },
    };
  }
}
